import React from 'react';
import { ButtonStyled, ButtonIcon, ButtonVariant, ButtonSize } from './styles';

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: ButtonVariant;
  size?: ButtonSize;
  icon?: React.ReactNode;
  iconPosition?: 'left' | 'right';
  loading?: boolean;
  block?: boolean;
  htmlType?: 'button' | 'submit' | 'reset';
  children?: React.ReactNode;
}

export const Button: React.FC<ButtonProps> = ({
  variant = 'primary',
  size = 'medium',
  icon,
  iconPosition = 'left',
  loading = false,
  block = false,
  htmlType = 'button',
  children,
  disabled,
  ...props
}) => {
  return (
    <ButtonStyled
      $variant={variant}
      $size={size}
      $block={block}
      $hasIcon={!!icon}
      $iconOnly={!!icon && !children}
      disabled={disabled || loading}
      type={htmlType}
      {...props}
    >
      {loading ? (
        <ButtonIcon $position="left">
          <span className="loading-spinner" />
        </ButtonIcon>
      ) : (
        <>
          {icon && iconPosition === 'left' && (
            <ButtonIcon $position="left">{icon}</ButtonIcon>
          )}
          {children && <span>{children}</span>}
          {icon && iconPosition === 'right' && (
            <ButtonIcon $position="right">{icon}</ButtonIcon>
          )}
        </>
      )}
    </ButtonStyled>
  );
};

export type { ButtonVariant, ButtonSize };
export default Button;
